export default __webpack_public_path__ + "static/media/banner_delivery_returns.aaeb0e16.jpg";